import translator from '@/locales';

export const lockedColumns = [
  {
    label: translator.t('ADVERTISEMENT.KEYWORD'),
    property: 'query',
    width: 225,
  },
];

export const dynamicColumns = [
  {
    label: translator.t('ADVERTISEMENT.KEYWORDPLANNER.COLUMNS_VALUE'),
    property: 'rate',
    component: () => import('./components/KeywordPlannerValueColumn'),
    width: 150,
  },
  {
    label: translator.t(
      'ADVERTISEMENT.KEYWORDPLANNER.COLUMNS_AVERAGE_IMPRESSION',
    ),
    property: 'averageImpression',
    component: () =>
      import('./components/KeywordPlannerAverageImpressionColumn'),
  },
  {
    label: translator.t('ADVERTISEMENT.KEYWORDPLANNER.COLUMNS_COMPETITION'),
    property: 'competition',
    component: () => import('./components/KeywordPlannerCompetitionColumn'),
  },
];
